import { useMutation } from '@tanstack/react-query';
import { useSharedLegalApi } from 'services/useSharedLegalApi';

export const useAcceptLegalTexts = () => {
  const { acceptLegalTexts } = useSharedLegalApi();

  return useMutation({ mutationFn: acceptLegalTexts });
};
